import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import {
  questionsListDO,
  updateQuestionsOrderDO,
  publishQuestionnaireDO,
  questionnarieListDo,
  updateBatchContentDO,
  translateQuestionnaireDO,
} from "utils/questionsUtils";
import { postLogDO } from "utils/logsUtils"
import { addAlert, useMaterialUIController, setCurrentDialog, useTranslations } from "context";
import { useNavigate } from "react-router-dom";
import { snakeCaseToCamelCase } from "utils/globalsUtils";
import { questionnaires } from "utils/questionsUtils";
import { TableColumnProps, TablePage } from "components/alove/TablePage";
import { formatDateTime } from "utils/globalsUtils";
import { TwoSizeChip } from "components/alove/Chips";
import { PermissionType } from "models/BO/BoRole";
import { networkGlobals } from "utils/networkUtils";
import { BatchContent, BatchContentType, BatchUIMobile } from "models/batch/BatchContent";
import { Question } from "models/batch/Question";
import { AddQuestionDialog } from "./addQuestionDialog";
import { TextQuestionDialog } from "./textQuestionDialog";
import { AloveDialog, DialogType } from "components/alove/AloveDialog";

import { GridEditInputCell } from "@mui/x-data-grid-pro";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
const MDSnackbar = require("components/MDSnackbar/index.js").default;
import { PageNumber } from "../../../accessNumbers";
let tableForOrder = [] as any[];

let questionaireID;

function QuestionList() {
  const { currentLanguage } = useTranslations();
  const pageNumber = PageNumber.ViewQuestionnaire;
  const navigate = useNavigate();
  
  const [controller, dispatch] = useMaterialUIController();

  const [refresh, setRefresh] = useState(false);

  let { bname } = useParams();

  useEffect(() => {
    ;
    questionaireID = questionnaires[snakeCaseToCamelCase(bname!)];
  },[bname]);

  useEffect(() => {
    setRefresh(!refresh);
  },[currentLanguage]);

  const columns:TableColumnProps<BatchContent>[] = [
    {
      headerName: "Type",
      field: "contentTypeId",
      width: 15,
      renderCell: (params) =>
        params.row.contentTypeId === 2 ? "Q" : params.row.contentTypeId === 4 ? "A" : "T",
      align: "center",
    },
    {
      headerName: "#",
      field: "id",
      width: 70,
      align: "center",
      valueFormatter: (v,row:any) => row.qid || row.bcid
    },
    {
      headerName: "Name",
      field: "text",
      valueGetter: (params,row) => row.contentTxtId || row.question?.txtId,
      flex: 4,
      editable: true,
      renderEditCell: (params) => {
        return params.row.contentTypeId == BatchContentType.Message ?
        <GridEditInputCell 
          {...params}
          /> : enterQuestion(params); 

      }
    },{
      headerName: "Res Rate",
      field: "responseCount",
      align: "center",
      valueFormatter: (v) => v ? `${v}%` : "",
    },
    {
      headerName: "Form",
      field: "visSettings",
      flex: 1,
      renderCell: (params) =>
        params.row.questionId ? "Question" :
         Object.keys(BatchUIMobile).find(k => BatchUIMobile[k] === params.row.visSettings?.ui_mobile) || ""
    },
    {
      headerName: "Updated",
      field: "updated",
      renderCell: (params) => formatDateTime(params.row.updated),
      flex: 1,
    },
    {
      headerName: "Status",
      field: "contentStateId",
      renderCell: (params) => statusElement(params.row),
      flex: 1,
      align: "center",
    },
  ];


  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
  };


  const onDragEnd = (result) => {
    ;
    tableForOrder = reorder(tableForOrder, result?.oldIndex, result?.targetIndex);
    ;
  };


  const updateQuestionOrder = async () => {
    // ;
    
    ;
    const updateStatus = await updateQuestionsOrderDO(questionaireID, tableForOrder);
    if (updateStatus === 200) {
      setRefresh(!refresh);
      addAlert(dispatch, "Question order was saved")
    }
  };

  const publishQuestionnaire = async () => {
    const publishRes = await publishQuestionnaireDO(questionaireID);
    addAlert(dispatch, "Questionnaire was published")
  };

  const translateQuestionnaire = async () => {
    const translateRes = await translateQuestionnaireDO(questionaireID);
    addAlert(dispatch, "Questionnaire was translated")
    setRefresh(!refresh);
  };

  const openModal = (item, type) => {
    navigate(`/questions/${Number(item?.questionId)}`);
  };

  const getAndPrepareTableData = async () => {
    questionaireID = questionnaires[snakeCaseToCamelCase(bname!)];
    ;
    if (!questionaireID) {
      const list = await questionnarieListDo();
      questionaireID = list.find(q=>q.name == snakeCaseToCamelCase(bname!))?.id;
      if (!questionaireID) {
        return []
      }
    }
    ;
    const questionList:BatchContent[] = await questionsListDO(questionaireID);
    questionList.forEach((q) => {
      q.id = q.id;
    });
    tableForOrder = questionList;
    return questionList;
  };
  const enterQuestion = (e) => {
    const item = e.row as BatchContent;
    if (item?.contentTypeId === BatchContentType.Question) {
      navigate(`/questions/${Number(item?.questionId)}`);
      return;
    }
    // For non-question batch content, navigate to the new edit batch content page
    navigate(`/batch-content/${item.id}/edit`);
  };


  const statusElement = (item:BatchContent) => {
    let label = "", color= "default"
    switch (item?.contentStateId) {
      case 1:
        label = "Draft";
        color = "default";
        break;
      case 2:
        label = "Published";
        color = "success";
        break;
      case 3:
        label = "Deactivated";
        color = "secondary";
        break;
    }
    return <TwoSizeChip label={label} color={color as any} />;
  };

  const processRowUpdate = (newRow:BatchContent, oldRow:BatchContent) => {
    newRow.contentTxtId = newRow.text;
    updateBatchContentDO(newRow.id, newRow).then((res) => addAlert(dispatch, "Content was updated"));
    return newRow;
  }


  return (
    <DashboardLayout >
      <DashboardNavbar pageTitle="Questionnairs" />
      
      <TablePage
        title="Questionnaire list"
        table={{
          columns,
          loadNext: getAndPrepareTableData,
          lineClick:  enterQuestion,
          processRowUpdate: processRowUpdate,
          onRowOrderChange: onDragEnd,
        }}
        refresh={refresh}
        actions={{
          title: "Actions",
          page:pageNumber,
          addActions: [
            {
              label: "Text",
              onClick: () => setCurrentDialog(dispatch, DialogType.AddTextQuestion),
              color: "secondary.light",
              variant: "contained",
              role: PermissionType.AddNew
            },
            {
              label: "Question",
              onClick: () => setCurrentDialog(dispatch, DialogType.AddQuestionnaire),
              color: "secondary",
              variant: "contained",
              role: PermissionType.AddNew
            },
          ],
          saveActions: [
            {
              label: "Update order",
              onClick: () => updateQuestionOrder()
            },
            {
              label: "Add new route rule",
              onClick: () => openModal("", "link"),
              role: PermissionType.AddNew
            },
            {
              label: "Publish",
              onClick: () => publishQuestionnaire(),
              variant: "contained",
              role: PermissionType.Publish
            },
            
            {
              label: "Translate",
              onClick: () => setCurrentDialog(dispatch, DialogType.DeleteWarning),
              role: PermissionType.Edit,
              hidden: currentLanguage === "en"
            }
          ],
        }}
      />
      
      <AddQuestionDialog questionaireID={questionaireID} afterCreate={() => {
        setRefresh(!refresh);
      }} />
      <TextQuestionDialog questionaireID={questionaireID} onSuccess={() => {
        setRefresh(!refresh);
      }} /><AloveDialog
      dialogType={DialogType.DeleteWarning}
      dialogTitle="Warning"
      dialogBody="Are you sure you want to translate the questionnaire?
      This action will override the existing translations."
      dialogConfirm="Translate"
      error
      handleConfirm={translateQuestionnaire}
    />
    </DashboardLayout>
  );
}
export default QuestionList;
